module.exports = __webpack_public_path__ + "img/preferences_illustration.b0302e93.png";